import React, { useState } from 'react'

// Components
import Filters from '../Filters/Filters'

// Types
import { StickyFiltersProps } from './StickyFilters.types'

// Styles
import styles from './StickyFilters.module.scss'

const StickyFilters: React.FC<StickyFiltersProps> = ({
  filters,
  onFiltersChange,
  assets,
  goBack,
  goForward,
  canGoBack,
  canGoForward,
  onReset,
}) => {
  const [isExpanded, setIsExpanded] = useState(true)

  const handleFilterExpand = (expanded: boolean) => {
    setIsExpanded(expanded)
  }

  return (
    <div className={styles.stickyWrapper}>
      <Filters
        filters={filters}
        onFiltersChange={onFiltersChange}
        assets={assets}
        onExpandChange={handleFilterExpand}
        goBack={goBack}
        goForward={goForward}
        canGoBack={canGoBack}
        canGoForward={canGoForward}
        onReset={onReset}
        initialExpanded={isExpanded}
      />
    </div>
  )
}

export default StickyFilters
